import Page from '@/components/Page'
import PostList from '@/components/Post/PostList'
import SearchBar from '@/components/Search/SearchBar'
import { Tab } from '@/components/Sidebar/config'
import { MOBILE_SHELL_SPRING_TRANSITION } from '@/constants/motion'
import { useIsMobileShellHidden, useScrollToTop } from '@/utils/dom'
import { EXPLORE_POSTS_QUERY_OPTIONS } from '@/utils/fetchers/post'
import { useIsMobileTabBarLayout } from '@/utils/hooks/useMediaQuery'
import usePageNeedRefreshSubscriber from '@/utils/hooks/usePageNeedRefreshSubscriber'
import usePosts from '@/utils/hooks/usePosts'
import { prepareToRefetchListQuery } from '@/utils/list'
import queryClient from '@/utils/queryClient'
import { useSuspenseInfiniteQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { motion } from 'motion/react'
import { useMemo } from 'react'
import { useTitle } from 'react-use'
import styles from './explore.module.css'

export const Route = createFileRoute('/explore')({
	component: ExplorePage,
	preload: false,
	loader: async () => {
		await queryClient.ensureInfiniteQueryData(EXPLORE_POSTS_QUERY_OPTIONS)
	},
})

export default function ExplorePage() {
	useTitle(`发现 - 即刻`)

	const { data, fetchNextPage, refetch, isFetchingNextPage } = useSuspenseInfiniteQuery(
		EXPLORE_POSTS_QUERY_OPTIONS
	)
	const postIds = useMemo(() => data.pages.flatMap((page) => page.data), [data.pages])
	const posts = usePosts(postIds)

	const scrollToTop = useScrollToTop()
	const isMobileShellHidden = useIsMobileShellHidden()
	const isMobileTabBarLayout = useIsMobileTabBarLayout()
	const isSearchBarHidden = isMobileTabBarLayout && isMobileShellHidden

	usePageNeedRefreshSubscriber(Tab.EXPLORE_POST, () => {
		scrollToTop()
		prepareToRefetchListQuery(EXPLORE_POSTS_QUERY_OPTIONS.queryKey)
		refetch()
	})

	return (
		<Page>
			<motion.div
				className={styles.searchBar}
				initial={false}
				animate={{
					y: isSearchBarHidden ? '-100%' : '0%',
				}}
				style={{
					pointerEvents: isSearchBarHidden ? 'none' : 'auto',
				}}
				transition={MOBILE_SHELL_SPRING_TRANSITION}
			>
				<SearchBar />
			</motion.div>
			<motion.div
				className={styles.postListWrapper}
				initial={false}
				animate={{
					y: isSearchBarHidden ? -70 : 0,
				}}
				transition={MOBILE_SHELL_SPRING_TRANSITION}
			>
				<PostList
					data={posts}
					isLoading={isFetchingNextPage}
					onLoadMore={async () => void (await fetchNextPage())}
				/>
			</motion.div>
		</Page>
	)
}
